module.exports = __webpack_public_path__ + "img/neirong_pc.1d06d55c.png";